<div [id]="listWidgetId">
  <finxone-web-frontend-products-list
    [widgetAttribute]="widgetAttributes"
    [contentStyle]="contentStyle"
    [textContentStyle]="textContentStyle"
    [productsList]="productsList"
    [isApiInProgress]="isApiInProgress"
    (productClicked)="onProductClicked($event)"
    (scrolled)="onScroll($event)"
    [appBuilderState]="appBuilderState"
    [isWorkflow]="isWorkflow"
    [selectedProductCode]="selectedProductCode"
  ></finxone-web-frontend-products-list>
</div>
